<div [matTooltip]="tooltip" [matTooltipDisabled]="!hasTooltip" class="button" [ngClass]="{ disabled, selected, single }">
  <button matIconButton aria-label="Toolbar Button" (click)="action.emit($event)" [disabled]="disabled">
    @if (icon) {
      <mat-icon class="material-icons-outlined icon">{{ icon }}</mat-icon>
    }
    <ng-content></ng-content>
  </button>
</div>
